import { render, staticRenderFns } from "./TextTemplate.vue?vue&type=template&id=b8a0e220&scoped=true"
import script from "./TextTemplate.vue?vue&type=script&lang=js"
export * from "./TextTemplate.vue?vue&type=script&lang=js"
import style0 from "./TextTemplate.vue?vue&type=style&index=0&id=b8a0e220&prod&lang=scss&scoped=true"
import style1 from "./TextTemplate.vue?vue&type=style&index=1&id=b8a0e220&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a0e220",
  null
  
)

export default component.exports